const USER_INFO_KEY = '_KU_AUTH_'
module.exports = {
	getToken() {
		return localStorage.getItem(USER_INFO_KEY) || ''
	},
	setToken(token) {
		localStorage.setItem(USER_INFO_KEY, token)
	},
	removeToken() {
		localStorage.removeItem(USER_INFO_KEY)
	}
}



// WEBPACK FOOTER //
// ./src/utils/auth.js